import React from "react";

/**
 * Tiny initials avatar with a deterministic colour per user.
 * Falls back to '?' if neither name nor email is available.
 */
const PALETTE = [
  "bg-emerald-500", "bg-sky-500", "bg-amber-500", "bg-fuchsia-500",
  "bg-rose-500", "bg-violet-500", "bg-cyan-500", "bg-orange-500",
  "bg-teal-500", "bg-indigo-500",
];

function hashIndex(str, mod) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h) % mod;
}

function initialOf(user) {
  if (!user) return "?";
  const src = user.name || user.email || "";
  const trimmed = src.trim();
  if (!trimmed) return "?";
  return trimmed[0].toUpperCase();
}

const SIZE_CLASSES = {
  xs: "h-5 w-5 text-[10px]",
  sm: "h-7 w-7 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-12 w-12 text-base",
};

export default function UserAvatar({ user, size = "sm", className = "", testId }) {
  const colour = PALETTE[hashIndex(user?.id || user?.email || "", PALETTE.length)];
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold ${SIZE_CLASSES[size]} ${colour} ${className}`}
      data-testid={testId}
      title={user?.name || user?.email || ""}
    >
      {initialOf(user)}
    </span>
  );
}
